import { Theme } from '@mui/material';


const Tabs = (theme: Theme) => {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#f6f7f8',
          borderRadius: 12,
          height: 40,
          minHeight: 40,
        },
        indicator: {
          display: 'none',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: 14,
          minHeight: 36,
          margin: '2px',
          padding: '0px 16px',
          borderRadius: 12,
          color: theme.palette.text.secondary,
          '&.Mui-selected': {
            color: theme.palette.text.secondary,
            fontWeight: 600,
            backgroundColor: 'white',
          },
        },
      },
    },
  };
};

export default Tabs;
